module.exports = __webpack_public_path__ + "static/subset-UniNeueLight-e157acadd5740f24e76927811a8c97ac.woff2";